import lazyLoad from 'core/util/lazyLoad';

const Map = lazyLoad(() => import('./Map'), { fallback: null });
export default Map;
